// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { libCards } from '@Organisms/Timeline/Cards';
import { TimelineEventList } from './eventList';
import { TimelineItemType } from '@Pages/Cases/Details/Timeline';
import { CaseOutput } from 'thehive-sdk';

export interface DisplayEventProps {
    currentEvent: TimelineItemType;
    caseData?: CaseOutput;
    eventList?: TimelineEventList;
    refetch?: () => void;
    hasPermissionEvent?: boolean;
}

export const DisplayEvent = React.memo((props: DisplayEventProps): ReactElement | null => {
    const objectType = props.currentEvent.entity;
    const Card = libCards[objectType];

    return Card ? <Card {...props} /> : null;
});
